import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'

import { HeaderComponent } from '../../components/header/header.component'
import { UserStore } from '../../stores/user.store'

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './main-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './main-page.component.scss',
})
export class MainPageComponent implements OnInit {
  private router = inject(Router)
  private userStore = inject(UserStore)

  ngOnInit() {
    // ルートパスの場合のみリダイレクト処理を実行
    if (this.router.url === '/' || this.router.url === '') {
      this.userStore.getOneSelf({ useCache: true }).subscribe((user) => {
        if (
          ['dai-ichi-life.co.jp', 'test.xpotential.co.jp'].some(
            (t) => t === user?.orgId,
          )
        ) {
          this.router.navigate(['/roleplay/session'])
        } else {
          this.router.navigate(['/home'])
        }
      })
    }
  }
}
